// TODO: translate doc files count
import { faDownload, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Table, TableBody, TableHead, TableRow, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Props } from "./interfaces";
import { Container, TableContainer, IconButton, TableCell } from "./styles";
import useAuthorization from "../../../custom-hooks/useAuthorization/useAuthorization";
import ExpandableItem from "../../../reusable-components/ExpandableItem/ExpandableItem";
import { handleDownloadFile } from "../../../services/documents/document-files-api.service";

import { AUTHORIZATIONS } from "../../../utils/constants/authorization-constants";
import { intlFormatDateWithHour } from "../../../utils/time-utils";
import { fileSize } from "../NewFile/utils";

const { DownloadDocuments, UploadDocuments } = AUTHORIZATIONS.LegalEntityAccess;
const { CompanyAccountsConfig } = AUTHORIZATIONS.SystemAccess;

const DocumentFilesTable = ({ document, handleDeleteFile, isWidget }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.upload_document.document_files_table"; // tRP = translation root path

  const isSysAdmin = useAuthorization([CompanyAccountsConfig]);
  const allowDownload = useAuthorization([DownloadDocuments]) || isSysAdmin;
  const allowUpload = useAuthorization([UploadDocuments]) || isSysAdmin;

  return (
    <Container>
      {document && !!document.files.length ? (
        <ExpandableItem
          expanded={false}
          expanderContainer={() => <>{`${document?.files?.length} file(s)`}</>}
          expandedContainer={
            <TableContainer>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>{`${t("common_words.name")}`}</TableCell>
                    <TableCell>{`${t(`${tRP}.fields.size`)}`}</TableCell>
                    <TableCell>{`${t(`${tRP}.fields.upload_date`)}`}</TableCell>
                    <TableCell>{`${t(`${tRP}.fields.user`)}`}</TableCell>
                    {allowDownload && <TableCell align="center">{`${t(`${tRP}.fields.download`)}`}</TableCell>}
                    {allowUpload && !isWidget && <TableCell align="center">{`${t(`${tRP}.fields.delete`)}`}</TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {document.files.map((file, idx) => (
                    <TableRow key={idx}>
                      <TableCell title={file.name}>{file.name.slice(0, 7)}...</TableCell>
                      <TableCell>{fileSize(file.size)}</TableCell>
                      <TableCell>{intlFormatDateWithHour(file.createdAt)}</TableCell>
                      <TableCell>{file.createdByUser?.name ?? file.createdByUser?.email ?? ""}</TableCell>
                      {allowDownload && (
                        <TableCell align="center">
                          <IconButton onClick={() => handleDownloadFile(file)}>
                            <FontAwesomeIcon icon={faDownload} />
                          </IconButton>
                        </TableCell>
                      )}
                      {allowUpload && !isWidget && (
                        <TableCell align="center">
                          <IconButton onClick={() => handleDeleteFile(file)}>
                            <FontAwesomeIcon icon={faTrash} />
                          </IconButton>
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          }
        />
      ) : (
        <Typography>{`${t(`${tRP}.no_files_message`)}`}</Typography>
      )}
    </Container>
  );
};

export default DocumentFilesTable;
